import React from 'react';
import { Stat, InfoCard, UpgradeNudge } from './shared';

export function Overview({ summary }) {
  const s = summary.counts;
  const st = summary.storage;
  const pct = Math.min(100, Math.round((st.mb_used / st.mb_limit) * 100));
  return (
    <div
      className="space-y-5 rounded-md p-6 sm:p-8"
      style={{ backgroundColor: 'hsl(var(--primary))' }}
      data-testid="overview-tab-panel"
    >
      <UpgradeNudge summary={summary} />
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <Stat label="Admins" value={`${s.admins} / ${summary.plan.limits.admins}`} />
        <Stat label="Family" value={s.family} />
        <Stat label="Memories" value={s.media_total} />
        <Stat label="QR scans" value={s.scans} />
      </div>

      <div className="ml-card">
        <div className="flex items-center justify-between">
          <div>
            <div className="ml-overline">Storage</div>
            <div className="font-serif text-2xl mt-1 text-[hsl(var(--primary))]">{st.mb_used} MB of {st.mb_limit} MB</div>
          </div>
          <div className="text-xs text-[hsl(var(--muted-foreground))]">{pct}%</div>
        </div>
        <div className="mt-4 h-2 rounded-full bg-[hsl(var(--muted))] overflow-hidden">
          <div className="h-full bg-[hsl(var(--accent))]" style={{ width: `${pct}%` }} />
        </div>
      </div>

      <div className="grid sm:grid-cols-3 gap-4">
        <InfoCard label="Public" value={s.media_public} hint="Visible to everyone" />
        <InfoCard label="Vault" value={s.media_vault} hint="Approved family only" />
        <InfoCard label="Private" value={s.media_private} hint="Admins only" />
      </div>

      {s.pending_requests > 0 && (
        <div className="ml-card border-[#D9B775]/60 bg-[hsl(var(--accent))]/10">
          <div className="ml-overline !text-[#D9B775]">Action needed</div>
          <div className="font-serif text-xl mt-1 !text-[#F4E5C2]">{s.pending_requests} pending Family Vault request{s.pending_requests > 1 ? 's' : ''}</div>
        </div>
      )}
    </div>
  );
}
